<template>
  <div class="log-oppea-box">
    <div class="item">操作用户：{{rowItem.operatedUserPO && rowItem.operatedUserPO.realName}}</div>
    <div class="item">被操作对象：{{form && form.updateTag}}</div>
    <div class="item">修改时间：{{rowItem.operatedTime}}</div>
    <el-row v-if="form">
      <el-col :span="12" v-if="form.beforeStr">
        <div class="grid-content">
          <div class="title">变更前</div>
          <template v-if="form.beforeStr.templateTeacher">
            <div class="item">技术老师id：{{form.beforeStr.templateTeacher.teacher_id}}</div>
          
            <div class="item">宣传图：<el-image style="width: 50px; height: 50px" :src="form.beforeStr.templateTeacher.promotion_img" :preview-src-list="[form.beforeStr.templateTeacher.promotion_img]" v-if="form.beforeStr.templateTeacher.promotion_img"></el-image></div>
             <div class="item">页面排序：{{form.beforeStr.templateTeacher.order_no}}</div>
            <div class="item">状态：{{form.beforeStr.templateTeacher.state?'启用':'禁用'}}</div>
            </template>
        </div>
      </el-col>
      <el-col :span="12" v-if="form.afterStr ">
        <div class="grid-content log-line">
          <div class="title">变更后</div>
          <template v-if="form.afterStr.templateTeacher">
            <div class="item">技术老师id：{{form.afterStr.templateTeacher.teacher_id}}</div>
            <div class="item">背景图：<el-image style="width: 50px; height: 50px" :src="form.afterStr.templateTeacher.promotion_img" :preview-src-list="[form.afterStr.templateTeacher.promotion_img]" v-if="form.afterStr.templateTeacher.promotion_img"></el-image></div>
            <div class="item">页面排序：{{form.afterStr.templateTeacher.order_no}}</div>
            <div class="item">状态：{{form.afterStr.templateTeacher.state?'启用':'禁用'}}</div>
          </template>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null
    }
  },
  created() {
    this.getLogShow()
  },
  methods: {
    getLogShow() {
      sysDataCompareLogApi.fetchById(this.rowItem.id).then(res => {
        this.form = res.data;

      })
    },
  }

}
</script>

<style lang="scss" scoped>
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
</style>
